import React from 'react';
import { Link } from 'react-router-dom';
import { GlassCard } from '../shared/GlassCard';
import { isGamePlayEnabled, saveLastGameId } from '../../data/games';

function UpcomingRoundCard({ row }) {
  return (
    <GlassCard
      variant="gold"
      className="relative min-h-[148px] overflow-hidden border border-hash-gold/25 p-0"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_80%_at_50%_0%,rgba(238,212,91,0.14),transparent_55%)]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-medora-blue/10 blur-2xl"
        aria-hidden
      />
      <div className="relative flex min-h-[148px] flex-col">
        <div className="flex items-center justify-between gap-2 border-b border-hash-gold/15 bg-dark/30 px-4 py-3">
          <div className="flex min-w-0 items-center gap-2.5">
            <img
              src={row.gameIcon}
              alt=""
              className="h-10 w-10 shrink-0 object-contain drop-shadow-[0_0_12px_rgba(238,212,91,0.25)]"
            />
            <img
              src={row.gameTextImage}
              alt={row.gameName}
              className="h-4 w-auto max-w-[88px] object-contain object-left"
            />
          </div>
          <span className="shrink-0 rounded-md border border-hash-gold/30 bg-hash-gold/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-widest text-hash-gold">
            Event
          </span>
        </div>
        <div className="flex flex-1 flex-col items-center justify-center gap-2.5 px-4 py-5 text-center">
          <div className="flex items-center gap-2 rounded-full border border-hash-gold/30 bg-gradient-to-r from-hash-gold/20 to-medora-blue/10 px-3.5 py-1.5 shadow-[0_0_20px_rgba(238,212,91,0.12)]">
            <span className="relative flex h-2 w-2 shrink-0">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-hash-gold opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-hash-gold" />
            </span>
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-hash-gold">
              Upcoming soon
            </span>
          </div>
        </div>
      </div>
    </GlassCard>
  );
}

function ActiveRoundCard({ row }) {
  const handlePlayNow = () => {
    saveLastGameId(row.gameId);
  };

  return (
    <GlassCard variant="blue" className="flex h-full flex-col p-4">
      <div className="flex flex-1 items-center gap-3">
        <img src={row.gameIcon} alt="" className="h-10 w-10 shrink-0 object-contain" />
        <div className="flex min-w-0 flex-1 flex-col items-start">
          <img src={row.gameTextImage} alt={row.gameName} className="mb-2 h-4 w-auto object-contain" />
          <div className="flex items-center gap-2">
            <div className="w-full text-[10px] font-semibold uppercase tracking-wider text-gray-500">
              Round
            </div>
            <div className="text-lg font-bold tabular-nums leading-tight text-hash-gold">
              {row.roundId === '—' ? '—' : `#${row.roundId}`}
            </div>
          </div>
          <div className="mt-2 flex items-center gap-2">
            <div className="w-full text-[10px] font-semibold uppercase tracking-wider text-gray-500">
              Sold tickets
            </div>
            <div className="text-sm font-bold tabular-nums leading-tight text-white">{row.soldTickets}</div>
          </div>
        </div>
      </div>
      <Link
        to="/games"
        onClick={handlePlayNow}
        className="mt-4 block w-full rounded-lg border border-hash-gold/30 bg-gradient-to-r from-hash-gold/20 to-medora-blue/20 py-2 text-center text-xs font-semibold text-hash-gold transition-colors hover:bg-hash-gold/10"
      >
        Play Now
      </Link>
    </GlassCard>
  );
}

function GameRoundCard({ row }) {
  if (!isGamePlayEnabled(row.gameId)) {
    return <UpcomingRoundCard row={row} />;
  }
  return <ActiveRoundCard row={row} />;
}

export default GameRoundCard;
